// extracted by mini-css-extract-plugin
export default {"deactive":"WebStoreItem_deactive__OVix6","hiddenBadge":"WebStoreItem_hiddenBadge__9+zg+","newBadge":"WebStoreItem_newBadge__RF3He"};